import { LoadingDots } from '@components/icons/LoadingDots'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ProfessionalDetail } from '@/components/Consultation/steps/Match/ProfessionalDetail'
import { useConsultation } from '@/hooks/useConsultation'
import { useStepper } from '@/hooks/useStepper'
import { CONSULTATION_STEPS, STEP_STEPPER } from '@/types/consultation'

export const Match = () => {
  const { t } = useTranslation()
  const { updateStep } = useStepper()
  const { consultation } = useConsultation()

  const [showPhysicianDetail, setShowPhysicianDetail] = useState(false)

  useEffect(() => {
    updateStep(STEP_STEPPER[CONSULTATION_STEPS.MATCH])
  }, [])

  const professional = consultation?.professional

  if (!professional) return null

  return (
    <div className="flex flex-1 flex-col items-center gap-4 p-4" data-testid="match-container">
      <div className="flex w-full flex-col items-center gap-4 rounded-md border border-primary bg-white p-4 shadow-strong">
        <img src={professional.profileImg} className="h-24 w-24 rounded-full" />

        <h2 className="text-2xl font-bold text-primary">
          {t(`professional_title_${professional.gender}`, {
            name: professional.name
          })}
        </h2>

        <p>{t('responding')}</p>

        <LoadingDots customClassName="text-primary" />

        <div className="flex w-full flex-wrap items-center justify-center gap-4">
          {professional.specialties?.map((specialty, index) => (
            <span key={index} className="rounded-3xl bg-primary-light py-2 px-4">
              {t(`specialty_${specialty}`)}
            </span>
          ))}
        </div>

        {professional.profileUrl && (
          <button
            className="mt-4 w-full border-t border-t-gray pt-4"
            onClick={() => {
              setShowPhysicianDetail(true)
            }}
            data-testid="view-profile-button"
          >
            <p className="font-bold uppercase text-primary">{t('view_profile')}</p>
          </button>
        )}
      </div>

      {showPhysicianDetail && <ProfessionalDetail professional={professional} onClose={() => setShowPhysicianDetail(false)} />}
    </div>
  )
}
